import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import Store from "./Store";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<Provider store={Store}>
	<BrowserRouter basename="/account">
		<App />
	</BrowserRouter>
</Provider>);
